import { useAuth } from "@/features/auth";
import { useApiClient } from "@/infrastructure/rest";
import { FeatureFlagsDto} from '@/shared/types';
import {useMutation, useQuery, useQueryClient} from '@tanstack/react-query';
import { FEATURE_FLAGS_QUERY_KEY } from "./constants";
import { FeatureFlags } from "./domain";

export function useFeatureFlagConfig() {
    const { isAuthenticated } = useAuth();
    const apiClient = useApiClient();

    return useQuery({
        queryKey: [FEATURE_FLAGS_QUERY_KEY],
        queryFn: async () => {
            const data = await apiClient.get<FeatureFlagsDto>("/config/feature-flags");
            return data ? FeatureFlags.fromDto(data) : null;
        },
        enabled: isAuthenticated,
    });
}

export function useUpdateFeatureFlagConfig()  {
    const apiClient = useApiClient();
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (updatedFlags: FeatureFlags) => {
            await apiClient.put("/beheer/feature-flags", { flags: updatedFlags });
        },
        onSuccess: async (_) => {
            await queryClient.invalidateQueries({queryKey: [FEATURE_FLAGS_QUERY_KEY] })
        },
    });
}

